export default __webpack_public_path__ + "static/media/chart_1@2x.71b6d695.png";